import React, { Component } from "react";
import { Select, Tooltip, Spin, Button, message } from "antd";
import ScGridTable from "@/components/display/table/gridTableCore";
import { getStationRank } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import ExportJsonExcel from 'js-export-excel';
class Top10Station extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      addDisabled:false,
      tableConfig: null,
      sortType: "0",
      sortOrder: "-1",
      dataSource: [],
      loading: false,
    };
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig();

    this.handleGetDataSource();
  }

  /** */
  initTableConfig = () => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessTop10StationTable",
        tableColumns: [
          {
            name: "排名",
            key: "serial",
            colType: "textCol",
            align: "center",
          },
          {
            name: "电站",
            key: "stubGroupName",
            colType: "textCol",
            align: "left",
            render: (text, record) => {
              return (
                <Tooltip title={text}>
                  <a
                    onClick={() => this.props.onAdd(
                      { key: "stationChargeSuccessDetail", titleText: "电站充电成功率" },
                      {
                        stationInfo: record,
                      },
                    )}>
                    {text.length >= 10 ? `${text.slice(0, 10)}...` : text}
                  </a>
                </Tooltip>
              );
            },
          },
          {
            name: "订单总数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功订单数",
            key: "successOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "失败订单数",
            key: "failureOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: (pagination, filters, sorter) => {
          console.log(sorter);
        },
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.state ? this.state.dataSource : [],
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  };

  // 类型排序改变事件
  sortTypeChange = async (value) => {
    await this.setState({
      sortType: value,
    });
    this.handleGetDataSource();
  };

  handleClick = () => {
    var data = [];
    if (this.state.dataSource != null && this.state.dataSource.length > 0)
    {
      data = this.state.dataSource;
    } else {
      message.error("暂无数据");
      return;
    }
    var option={};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        let obj = {}
        obj['排名'] = data[i]['serial'];
        obj['电站'] = data[i]['stubGroupName'];
        obj['订单总数'] = data[i]['totalOrder'];
        obj['成功订单数'] = data[i]['successOrder'];
        obj['失败订单数'] = data[i]['failureOrder'];
        obj['成功率'] = data[i]['successRate'] + '%';
        dataTable.push(obj);
      }
    }
    var header = ['排名', '电站', '订单总数', '成功订单数', '失败订单数', '成功率'];
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";
    option.fileName = this.props.chooseDate.format(format) + 'Top50电站'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  // 升降序改变事件
  sortOrderChange = async (value) => {
    await this.setState({
      sortOrder: value,
    });
    this.handleGetDataSource();
  };

  // 获取数据源
  handleGetDataSource = () => {
    this.setState({
      loading: true,
    });
    fetchHandler(getStationRank, {
      ...this.props.params,
      topNum: 50,
      sortType: this.state.sortType,
      sortWay: this.state.sortOrder,
      isStubGroup: 1,
      startTime: this.props.chooseDate.format(this.getFormatter()),
      endTime: this.props.endDate.format(this.getFormatter()),
      time: undefined,
    }).then((res) => {
      if (res && res.code === "success") {
        // res.data = [{"stubId":null,"stubGroupId":"32bf8c72-c1ce-4237-b663-d2c63521014d","stubGroupName":"武进国家高新区创新产业园","totalOrder":37,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":1},{"stubId":null,"stubGroupId":"32bf8c72-c1ce-4237-b663-d2c63521014d","stubGroupName":"武进国家高新区创新产业园","totalOrder":37,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":1},{"stubId":null,"stubGroupId":"32bf8c72-c1ce-4237-b663-d2c63521014d","stubGroupName":"武进国家高新区创新产业园","totalOrder":37,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":1},{"stubId":null,"stubGroupId":"32bf8c72-c1ce-4237-b663-d2c63521014d","stubGroupName":"武进国家高新区创新产业园","totalOrder":37,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":1},{"stubId":null,"stubGroupId":"32bf8c72-c1ce-4237-b663-d2c63521014d","stubGroupName":"武进国家高新区创新产业园","totalOrder":37,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":1},{"stubId":null,"stubGroupId":"5d507d8d-6fcd-4bae-a5f3-55a4508909ea","stubGroupName":"西门子汽车充电站（beta用不对外开放）","totalOrder":10,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":2},{"stubId":null,"stubGroupId":"895d65ac-61b1-438a-b384-e12dfc711ce9","stubGroupName":"平台开发测试站交\\/直流站（开迈斯超级充电站常州武进高新区创新产业园测试站）","totalOrder":2,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":3},{"stubId":null,"stubGroupId":"fed02856-12a6-4bcb-8868-051771ddb007","stubGroupName":"淹城乐园","totalOrder":2,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":4},{"stubId":null,"stubGroupId":"67d6d35f-99de-42c5-8b15-be72dcbc28a8","stubGroupName":"上海测试充电站","totalOrder":1,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":5},{"stubId":null,"stubGroupId":"2ac6d71d-5b69-459f-9cee-159144f54c52","stubGroupName":"节卡智能充电站","totalOrder":1,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":6},{"stubId":null,"stubGroupId":"9d44d3c6-b1ee-435f-b9b6-527b594beacc","stubGroupName":"南夏墅0310一号站","totalOrder":1,"successOrder":0,"failureOrder":0,"successRate":"0.00","serial":7}];
        this.setState(
          {
            dataSource: res.data,
          },
          () => {
            this.initTableConfig();
          },
        );
      }
      this.setState({
        loading: false,
      });
    });
  };

  getFormatter = () => {
    return this.props.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  render() {
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";

    return (
      <div className="exp-spin">
        <Spin spinning={this.state.loading}>
          <div className="section" style={{ height: "100%" }}>
            <div className="title-box">
            <div style={{    display: 'flex',alignItems: 'center'}}>
              <div className="title">{this.props.chooseDate.format(format)} TOP50电站</div>
              <Button
              onClick={this.handleClick}
              type="primary"
              disabled={this.state.addDisabled}
              style={{ margin: "5px" }}>
              导出
            </Button>
            </div>
              <div className="search-box">
                <span className="select-label">排序方式：</span>
                <Select
                  value={this.state.sortType}
                  onChange={this.sortTypeChange}
                  style={{ width: "120px", marginRight: "8px" }}>
                  {this.props.sortTypeOptions.map((v) => (
                    <Select.Option value={v.value}>{v.name}</Select.Option>
                  ))}
                </Select>
                <Select
                  value={this.state.sortOrder}
                  onChange={this.sortOrderChange}
                  style={{ width: "120px" }}>
                  {this.props.sortOrderOptions.map((v) => (
                    <Select.Option value={v.value}>{v.name}</Select.Option>
                  ))}
                </Select>
              </div>
            </div>
            <ScGridTable config={this.state.tableConfig} />
          </div>
        </Spin>
      </div>
    );
  }
}

export default Top10Station;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/top10Station.js